module.exports = __webpack_public_path__ + "static/media/bids.68a032d3.svg";